import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACK = { genres: ["Drama", "Documentary", "Thriller", "Comedy", "Mystery", "Cultural", "Animation", "Romance", "AI Film"], ai_film: "AI Film", ai_subgenres: [] };
let cache = null;

// Genre catalogue from the server (AI Film sub-genres are admin-editable).
export default function useGenres() {
  const [data, setData] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    api.get("/genres").then(({ data: d }) => { cache = d; setData(d); }).catch(() => {});
  }, []);
  return data;
}

export const refreshGenres = (d) => { cache = d ? { ...(cache || FALLBACK), ...d } : null; };
export const genreLabel = (f) => (f?.sub_genre ? `${f.genre} · ${f.sub_genre}` : f?.genre);
